const PageTitleBackground = ({ nodeRef }) => (
  <div className="css-xdcd7r" ref={nodeRef}></div>
);

export default PageTitleBackground;
